import { render } from "./template.vue?vue&type=template&id=514b2a4d&lang=pug"
const script = {}

import "./template.vue?vue&type=style&index=0&id=514b2a4d&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__